"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RequirePermission - Layout route component for permission-based access control.
 *
 * Wraps a group of routes and enforces a single permission code.
 * Must be used inside a React Router <Route element={...}> (renders <Outlet />).
 *
 * SECURITY NOTE: This is a UX guard, not a security boundary.
 * The backend validates the JWT on every API call. These guards prevent
 * unauthorised navigation and reduce information exposure in the UI.
 */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("../providers/AuthProvider");
const RequirePermission = ({ permission, redirectTo = '/unauthorized', logoutOnDeny = false, }) => {
    const { loading, hasPermission, logout } = (0, AuthProvider_1.useAuth)();
    const permitted = hasPermission(permission);
    // Side effects must not run during render (React Strict Mode safe).
    // Logout is deferred to an effect so the component renders null first,
    // then ProtectedRoutes auto-navigates to /login when isAuthenticated becomes false.
    (0, react_1.useEffect)(() => {
        if (!loading && !permitted && logoutOnDeny) {
            // Generic message — does not reveal which permission is missing (OWASP A01).
            logout('You do not have access to DegreePlan.');
        }
    }, [loading, permitted, logoutOnDeny, logout]);
    // Wait for auth to resolve — ProtectedRoutes already shows a spinner.
    if (loading)
        return null;
    // Logging out: return null and let ProtectedRoutes redirect to /login.
    if (!permitted && logoutOnDeny)
        return null;
    if (!permitted) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: redirectTo, replace: true });
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
};
exports.default = RequirePermission;
